import { createAsyncReducer } from "@telstra-connect/standard-actions/reducers";
import {
    IGetCartAction,
    IGetCartForbiddenAction,
    IGetCartErrorAction,
    IGetCartSuccessAction,
} from "../actions/get-cart-items";
import { IStoreIntState } from "../state";
import { initialState } from "../state/initial-state";

export type LoadCartAction =
    | IGetCartAction
    | IGetCartForbiddenAction
    | IGetCartErrorAction
    | IGetCartSuccessAction;

const init = (state: IStoreIntState, action: LoadCartAction) => ({
    ...state,
    cartInfo: {
        ...state.cartInfo,
        status: action.status,
    },
});

const success = (state: IStoreIntState, action: LoadCartAction) => {
    return {
        ...state,
        cartInfo: {
            ...state.cartInfo,
            status: action.status,
            data: (action as IGetCartSuccessAction).data.data,
            orderStatus: (action as IGetCartSuccessAction).data.orderStatus
        },
    };
};

const failure = (state: IStoreIntState, action: LoadCartAction) => ({
    ...state,
    cartInfo: {
        ...initialState.cartInfo,
        status: action.status,
        error: (action as IGetCartErrorAction).error,
    },
});


export const getCartReducer = createAsyncReducer(
    initialState,
    init,
    success,
    failure,
);
